import React from 'react';

import LatestStatus from '../latestStatus.jsx';
import viewStatuses from '../viewStatus.js';

export const viewStatusToUrl = {
    [viewStatuses.NOT_STARTED]: '/hva-er-trygg-betaling',
    [viewStatuses.AGREEMENT_SENT]: '/avtale-sendt',
    [viewStatuses.AGREEMENT_ACCEPTED]: '/avtale-godkjent',
    [viewStatuses.PAID]: '/godkjenn-eller-avsla-vare',
    [viewStatuses.PAYMENT_DELAYED]: '/godkjenn-eller-avsla-vare',
    [viewStatuses.PAYMENT_REVERTED]: '/handel-hevet',
    [viewStatuses.ITEM_APPROVED]: '/varen-er-godkjent',
    [viewStatuses.DISCOUNT_SUGGESTED]: '/losning/avslag-foreslatt',
    [viewStatuses.DISCOUNT_APPROVED]: '/losning/enighet-om-avslag',
};

export default () => <LatestStatus viewStatusToUrl={viewStatusToUrl} />;



// WEBPACK FOOTER //
// ./safeTrade/buyer/safeTradeBuyerStatus.jsx